import { useHistory } from 'react-router';

import EvaluationSubmission from './evaluation-submission/EvaluationSubmission';

export default function Conversation({
	userID,
	conversationID,
}: {
	userID?: string;
	conversationID: string;
}) {
	const history = useHistory();

	const returnUrl = (() => {
		const params = new URLSearchParams(history.location.search);
		if (params.has('return') && params.get('return')?.startsWith('/')) {
			return params.get('return');
		}

		if (userID) {
			return `/users/${userID}/conversations`;
		}
		return '/conversations';
	})()!;

	return <EvaluationSubmission returnUrl={returnUrl} evaluationSubmissionID={conversationID} />;
}
